<template>
  <VDialog v-model="isVisible" width="400px" persistent>
    <VeeForm ref="observer">
      <VCard>
        <VCardTitle>
          {{dialogData?.classType === 2 ?$t('C30101.C30101InsertSingleClassDialog.zR7hmQwdt9Q3QKdTmFjGv') : $t('C30101.C30101InsertSingleClassDialog._sqR8PYbYL7VCJjR4luaB')}}
        </VCardTitle>
        <VCardText v-debug>
          <h3>dialogData</h3>
          {{dialogData}}
        </VCardText>
        <VCardText v-if="dialogData">
          <table>
            <colgroup>
              <col style="width: fit-content;">
              <col style="width: fit-content;">
              <col style="width: max-content;">
            </colgroup>
            <tr>
              <td>{{ $t('C30101.C30101InsertSingleClassDialog.upVbPYtmRdESKF3scxLoU') }}</td>
              <td>:</td>
              <td class="pl-2">
                {{dialogData.timeSlot.time_display_name}}
                {{
                  {
                    0: '(90分)',
                    1: '(40分前半)',
                    2: '(40分後半)',
                  }[outputData.updateTimeSlot ? 0 : dialogData.timeSlot.time_division]
                }}
              </td>
            </tr>
            <tr>
              <td></td>
              <td></td>
              <td class="pl-2">
                <VCheckbox
                  v-model="outputData.updateTimeSlot"
                  :disabled="!dialogData.allowUpdate"
                  hide-details="auto"
                  :label="$t('C30101.C30101InsertSingleClassDialog.UMzFIWjd8DnP6HlPeIuz5')"
                  class="pa-0 ma-0 pb-4"
                />
              </td>
            </tr>
            <tr>
              <td class="pb-2">{{ $t('C20101.CourseTable.ksu') }}</td>
              <td class="pb-2">:</td>
              <td class="pl-2 pb-2">
                <VAutocomplete
                  v-model="outputData.capacity"
                  :items="[
                    { label: $t('C30101.C30101InsertSingleClassDialog.pD038nAPNTm6LNU7AjWCn'), value: 1 },
                    { label: $t('C30101.C30101InsertSingleClassDialog.lVFVIATdhNEKB1LuI2Ebz'), value: 2 },
                  ]"
                  hide-details="auto"
                  item-title="label"
                  item-value="value"
                  density="compact"
                  variant="outlined"
                  clearable
                />
              </td>
            </tr>
            <tr>
              <td>{{ $t('C20101.CourseTable.ke-mu') }}</td>
              <td>:</td>
              <td class="pl-2">
                <VAutocomplete
                  v-model="outputData.selectedSubject"
                  :items="dialogData.classList || []"
                  hide-details="auto"
                  item-title="menuLabel"
                  return-object
                  density="compact"
                  variant="outlined"
                  clearable
                />
              </td>
            </tr>
          </table>
        </VCardText>
        <VCardText v-debug>
          <h3>outputData</h3>
          {{outputData}}
        </VCardText>
        <VCardActions>
          <VSpacer></VSpacer>
          <VBtn
            color="primary"
            size="small"
            :disabled="Object.keys(outputData?.selectedSubject || {}).length === 0 || !outputData.capacity"
            @click="emitOk"
          >
            OK
          </VBtn>
          <VBtn variant="text" size="small" @click="emitCancel">
            {{ $t('common.cancel') }}
          </VBtn>
        </VCardActions>
      </VCard>
    </VeeForm>
  </VDialog>
</template>

<script>
import DialogMixin from '@/mixins/DialogMixin.js';
export default {
  components:{
  },
  mixins:[
    DialogMixin
  ],
  data() {
    return {
    };
  },
  methods:{
  }

}
</script>

<style scoped>
span {
  font-size: 1rem
}
.v-card__text{
  font-size: 1rem;
}
</style>
